import { createFileRoute } from '@tanstack/react-router'
import { WebChat } from '../../../../components/WebChat'

export const Route = createFileRoute('/desa/$slug/warga/chat')({
  component: WebChat,
})
